import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { BaseHttpClientService } from './base-http-client.service';
import { PdfExportCertificatesGeLevel1Service } from './pdf-export-certificates/pdf-export-certificates-ge-level-1.service';
import { PdfExportCertificatesGeLevel2Service } from './pdf-export-certificates/pdf-export-certificates-ge-level-2.service';
import { PdfExportCertificatesVentusLevel1Service } from './pdf-export-certificates/pdf-export-certificates-ventus-level-1.service';
import { PdfExportCertificatesVentusLevel2Service } from './pdf-export-certificates/pdf-export-certificates-ventus-level-2.service';

@Injectable()
export class TrainingCertService extends BaseHttpClientService {
  private readonly ventusCertificateLevel1SiteId = 140;
  private readonly geCertificateLevel1SiteId = 141;
  private readonly geCertificateLevel2SiteId = 142;
  private readonly ventusCertificateLevel2SiteId = 143;
  private readonly certificateSiteIds = [this.ventusCertificateLevel1SiteId, this.geCertificateLevel1SiteId, this.ventusCertificateLevel2SiteId, this.geCertificateLevel2SiteId];

  constructor(
    private http: HttpClient,
    private pdfExportVentusLevel1Service: PdfExportCertificatesVentusLevel1Service,
    private pdfExportGeLevel1Service: PdfExportCertificatesGeLevel1Service,
    private pdfExportVentusLevel2Service: PdfExportCertificatesVentusLevel2Service,
    private pdfExportGeLevel2Service: PdfExportCertificatesGeLevel2Service
  ) {
    super()
  }

  public shouldSendCertificatePdf(siteIds: any[]) {
    return siteIds.some(siteId => this.certificateSiteIds.includes(parseInt(siteId)));
  }

  public downloadPdfCert(certificateDetails, siteId) {
    const startDate = certificateDetails.startDate.toLocaleDateString('en-GB');
    const expiryDate = certificateDetails.expiryDate.toLocaleDateString('en-GB');

    if (siteId === this.ventusCertificateLevel1SiteId) {
      this.pdfExportVentusLevel1Service.downloadCertificate(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.geCertificateLevel1SiteId) {
      this.pdfExportGeLevel1Service.downloadCertificate(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.ventusCertificateLevel2SiteId) {
      this.pdfExportVentusLevel2Service.downloadCertificate(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.geCertificateLevel2SiteId) {
      this.pdfExportGeLevel2Service.downloadCertificate(certificateDetails, startDate, expiryDate);
    } else {
      throw new Error('Something went wrong, requesting induction certificate');
    }
  }

  public submitPdfCert(courseId, captchaToken, certificateDetails, siteId): Observable<any> {
    const jsonDataMultipartName = 'certificateDTO';
    const fileMultipartName = 'certFile';

    const body = {
      courseId: courseId,
      capchaToken: captchaToken,
    };

    // multipart/form-data, append each part
    const formData = new FormData();
    formData.append(jsonDataMultipartName, new Blob([JSON.stringify(body)], { type: 'application/json' }));

    const startDate = certificateDetails.startDate.toLocaleDateString('en-GB');
    const expiryDate = certificateDetails.expiryDate.toLocaleDateString('en-GB');

    let blob;
    if (siteId === this.ventusCertificateLevel1SiteId) {
      blob = this.pdfExportVentusLevel1Service.getCertificateFile(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.geCertificateLevel1SiteId) {
      blob = this.pdfExportGeLevel1Service.getCertificateFile(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.ventusCertificateLevel2SiteId) {
      blob = this.pdfExportVentusLevel2Service.getCertificateFile(certificateDetails, startDate, expiryDate);
    } else if (siteId === this.geCertificateLevel2SiteId) {
      blob = this.pdfExportGeLevel2Service.getCertificateFile(certificateDetails, startDate, expiryDate);
    } else {
      throw new Error('Something went wrong, requesting induction certificate');
    }

    let file: File = new File([blob], `${certificateDetails.siteName} - ${certificateDetails.inductionName} Certificate.pdf`);
    formData.append(fileMultipartName, file, file.name);

    return this.http
      .post(environment.apiUrl + 'api/ext-worker-user-course/send-certificate', formData, { responseType: 'text' })
      .pipe(map((response: string) => response))
      .pipe(
        catchError((error) => {
          console.log('Error', error.error);
          if (error.error && error.error.status === 400 && error.error.errorKey === 'Infected') {
            throw new Error('The file is infected and cannot be uploaded!');
          }
          return this.handleError(error);
        })
      );
  }

}
